var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnFavoriteUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77148 1.12598C7.84871 0.95314 8.07371 0.931602 8.1875 1.06152L8.22852 1.12598L9.86426 4.79688C9.95972 5.01079 10.1489 5.16553 10.373 5.21973L10.4707 5.2373L14.4668 5.65918C14.6552 5.67916 14.7449 5.88577 14.6562 6.03418L14.6074 6.09277L11.623 8.7832C11.449 8.94003 11.3593 9.16756 11.377 9.39746L11.3916 9.49609L12.2246 13.4268C12.2639 13.612 12.0952 13.7618 11.9268 13.7236L11.8555 13.6953L8.375 11.6875C8.17217 11.5705 7.92798 11.5559 7.71484 11.6436L7.625 11.6875L4.14453 13.6953C3.98069 13.7898 3.78674 13.6755 3.77051 13.5039L3.77539 13.4268L4.6084 9.49609C4.65701 9.2669 4.59571 9.03014 4.44629 8.85449L4.37695 8.7832L1.39258 6.09277C1.25188 5.96598 1.30029 5.74589 1.45898 5.67773L1.5332 5.65918L5.5293 5.2373C5.7621 5.21273 5.96795 5.08088 6.08887 4.88477L6.13574 4.79688L7.77148 1.12598Z",
    stroke: "#AAAAAA",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFavoriteUnselected);
export default __webpack_public_path__ + "static/media/icn_favorite_unselected.99806bae601bd39673c22658a5f16939.svg";
export { ForwardRef as ReactComponent };